/**
 * Created by slava on 24.03.17.
 */

const CleverappsWindow = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        ComponentMap.attach(this, new WindowComponent(this._composeBundles(...args), this.getLoadingTasks(...args), args[0], this.listLazyUrls(...args)));
    },

    onWindowLoaded: function (options) {
        this.buildWindow(options);

        ComponentMap.get(this, WindowComponent).attachSoundEffects();
        cleverapps.effects.fire("ui.window.open", this);
    },

    rebuildWindow: function (content) {
        this.params.content = content;
        this.removeAllChildren(true);
        this.buildWindow(this.params);
    },

    buildWindow: function (options) {
        options = options || {};
        this.params = options;

        if (options.closeButtonDelay) {
            if (typeof options.closeButtonDelay !== "number") {
                options.closeButtonDelay = 0.5;
            }
        }
        this.params.closeButtonManual = options.closeButtonManual;
        this.params.closeButtonDelay = options.closeButtonDelay || 0;

        let styles = cleverapps.styles.Window;
        if (options.styles) {
            styles = cleverapps.overrideStyles(styles, options.styles, true);
        }
        this.styles = styles;

        this.name = options.name || options.title || "window";

        this.content = options.content;
        this.withBg = !options.noBackground && !styles.noBackground;

        this.withShadow = options.withShadow !== false;

        this.buttons = this.createWindowButtons();

        if (options.shareId && ShareCheckBoxModel.isAvailable()) {
            this.shareCheckBoxModel = new ShareCheckBoxModel(options.shareId, this);

            this.shareCheckBox = new ShareCheckBox(this.shareCheckBoxModel);
        }

        if (options.closeButton !== false && styles.closeButton !== false) {
            this.closeButton = this.createCloseButton();
        }

        if (options.loginOrInvite) {
            this.loginOrInvite = cleverapps.FBLoginOrInvite();
        }

        if (this.withBg) {
            this.createWindowWithBg();
        } else {
            this.createWindowWithoutBg();
        }

        this.debugId = this.name;

        this.windowSize = this.window.getContentSize();

        if (this.params.title && this.withBg) {
            this.windowTitle = this.createWindowTitle();
            this.window.addChild(this.windowTitle);
            this.windowTitle.refresh(this.window);
        }

        if (options.help && !styles.HelpButton.lovesTitle) {
            const helpButton = this.createHelpButton(options.help);
            this.window.addChild(helpButton);
        }

        if (cleverapps.oneOf(this.closeButton, CloseRoundButton)) {
            this.addChild(this.closeButton);
        } else if (this.closeButton instanceof CloseButton) {
            this.window.addChild(this.closeButton);
        }

        const decorStyles = cleverapps.skins.getSlot("windowDecors", {
            decors: styles.decors,
            window: this,
            level: options.level
        });
        if (decorStyles) {
            this.decors = new Decors(this, decorStyles);
        }

        if (options.closeButton !== false || options.closeByHardwareBackButton) {
            this.closeByHardwareBackButton = this.createListener(() => {
                if (cleverapps.focusManager.checkEventNode(this)) {
                    this.close();
                }
            });
        }

        if (options.fireworks) {
            this.fireworks = new Fireworks();
            this.fireworks.setAlignment(this.width / 2, this.height / 2);
            this.fireworks.setLocalZOrder();
            this.addChild(this.fireworks);
        }

        if (options.offerWindowButton) {
            options.offerWindowButton.positioningStartOffset = this.window.width / 2;
            this.windowOffer = new WindowOffer(this, options.offerWindowButton);
        }

        const person = this._findInjectedPersons() || (this.getPerson && this.getPerson());
        if (person) {
            this.persons = new WindowPersons(person, this, [this.wrapper, this.tapToContinue]);
        }

        this.windowPadding = this.getWindowPadding();
    },

    createWindowButtons: function () {
        let items = [];

        if (this.params.button) {
            this.params.button.onClicked = this.params.button.onPressed || this.close.bind(this);
            items.push(new BottomButton(this.params.button));
        }

        if (this.params.buttons) {
            items = items.concat(this.params.buttons);
        }

        if (items.length) {
            return new Buttons(items);
        }
    },

    createWindowTitle: function () {
        const title = new WindowTitle(this.withBg, this.params.title, this.styles.HelpButton.lovesTitle && this.params.help);
        title.setDecors(this.decors);
        return title;
    },

    createWindowWithoutBg: function () {
        const tapToContinueItems = [];

        if (this.buttons) {
            tapToContinueItems.push(this.buttons);
        }

        if (this.closeButton instanceof TapToContinue) {
            tapToContinueItems.push(this.closeButton);
        }

        if (tapToContinueItems.length) {
            this.tapToContinue = new cleverapps.Layout(tapToContinueItems, {
                direction: cleverapps.UI.VERTICAL,
                margin: this.styles.Footer.margin,
                padding: this.styles.TapToContinue.padding
            });
            this.tapToContinue.setLocalZOrder(2);
            this.tapToContinue.setCascadeOpacityEnabledRecursively(true);
            this.addChild(this.tapToContinue);
        }

        this.contentItems = cleverapps.UI.wrapWithPadding(this.content);
        this.contentWrapper = cleverapps.UI.wrapWithPadding(this.contentItems);
        this.window = cleverapps.UI.wrapWithPadding(this.contentWrapper);

        const windowItems = [this.window];

        if (this.params.title) {
            this.windowTitle = this.createWindowTitle();
            windowItems.unshift(this.windowTitle);
        }

        this.window.setLocalZOrder(1);

        this.wrapper = new cleverapps.Layout(windowItems, {
            direction: cleverapps.UI.VERTICAL,
            margin: this.styles.titleMargin
        });
        this.wrapper.avoidNode = "Window";
        this.wrapper.setLocalZOrder(1);
        this.addChild(this.wrapper);

        this.wrapper.setAlignment(this.width / 2, this.height / 2);

        if (this.params.title) {
            this.windowTitle.refresh(this.window);
        }

        this.createWindowFooter();
    },

    createWindowWithBg: function () {
        this.contentItems = new cleverapps.Layout([this.content, this.shareCheckBox, this.buttons].filter(Boolean), {
            margin: this.styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        const padding = Array.isArray(this.styles.padding) ? this.styles.padding[cleverapps.resolution.mode] : this.styles.padding;

        this.contentWrapper = cleverapps.UI.wrapWithPadding(this.contentItems, !this.params.noPadding && padding);
        this.contentWrapper.setLocalZOrder(1);

        const borderPadding = !this.params.noBorder && this.styles.border
            ? cc.multPadding(cc.padding(this.styles.border), this.styles.border.scale[cleverapps.resolution.mode]) : cc.padding();

        this.window = cleverapps.UI.wrapWithPadding(this.contentWrapper, borderPadding);
        this.window.setLocalZOrder(1);

        cleverapps.UI.wrapWithPadding(this.window, this.getWindowMinPadding(this.window.getContentSize()), true);

        this.bg = this.createBackground();
        this.window.addChild(this.bg);
        this.bg.setLocalZOrder(-1000);

        this.adjustBackground();

        this.wrapper = cleverapps.UI.wrapWithPadding(this.window);
        this.wrapper.avoidNode = "Window";
        this.wrapper.setLocalZOrder(1);
        this.addChild(this.wrapper);

        const foreground = this.params.foreground || this.styles.Foreground && this.styles.Foreground.image;
        if (foreground) {
            this.foreground = this.createForeground(foreground);
            this.window.addChild(this.foreground);
        }

        if (this.buttons) {
            this.buttons.contentItemsPosition = this.buttons.getPosition();
            this.buttons.replaceParentSamePlace(this.window);
        }

        this.wrapper.setAlignment(this.width / 2, this.height / 2);

        if (this.tabs && this.tabs.isVisible()) {
            const contentBox = this.contentWrapper.getGlobalBoundingBox();
            const tabsBox = this.tabs.getGlobalBoundingBox();
            this.contentWrapperPadding = cc.paddingSubPadding(cc.rectUnionPadding(contentBox, tabsBox), borderPadding);
            cleverapps.UI.wrapWithPadding(this.contentWrapper, this.contentWrapperPadding, true);
        }

        if (this.tabs) {
            this.tabs.setMoveUpParent(this.foreground || this);
        }

        this.createWindowFooter();
    },

    createWindowFooter: function () {
        const footerItems = [];

        if (this.params.footNote) {
            footerItems.push(this.params.footNote);
        }

        if (this.shareCheckBox && !this.withBg) {
            this.shareCheckBox.setOpacity(180);
            footerItems.push(this.shareCheckBox);
        }

        if (this.loginOrInvite) {
            footerItems.push(this.loginOrInvite);
        }

        if (footerItems.length) {
            this.windowFooter = new cleverapps.Layout(footerItems, {
                direction: cleverapps.UI.VERTICAL,
                margin: this.styles.Footer.margin
            });
            this.windowFooter.setAlignment(this.styles.Footer);
            this.windowFooter.setLocalZOrder(2);
            this.addChild(this.windowFooter);
        }
    },

    adjustTapToContinue: function () {
        if (!this.tapToContinue) {
            return;
        }

        const footerBox = this.windowFooter ? this.windowFooter.getBoundingBox() : undefined;
        const footerTop = footerBox ? footerBox.y + footerBox.height : 0;

        this.tapToContinue.setScale(1);
        this.tapToContinue.setAlignment(this.wrapper.x, footerTop + this.tapToContinue.height / 2);
    },

    adjustBackground: function () {
        if (!this.withBg || !this.bg) {
            return;
        }

        const scale = this.getBackgroundScale();
        const size = this.window.getContentSize();

        this.bg.setScale(scale);
        this.bg.setContentSize2(size.width / scale, size.height / scale);
        this.bg.setAlignment(this.window.width / 2, this.window.height / 2);
    },

    adjustForeground: function () {
        if (!this.withBg || !this.bg || !this.foreground) {
            return;
        }

        let rect = cc.rect(0, 0, this.window.width, this.window.height);

        this.foreground.setScale(this.bg.scale);

        if (this.styles.Foreground) {
            const padding = cc.mergePaddings([
                cc.multPadding(cc.padding(this.styles.Foreground.padding), this.foreground.scale),
                cc.multPadding(cc.padding(this.styles.Foreground.contentPadding), this.contentWrapper.scale)
            ]);

            rect = cc.rectSubPadding(rect, padding);
        }

        this.foreground.setAlignment(rect.x, rect.y);
        this.foreground.setContentSize2(rect.width / this.foreground.scale, rect.height / this.foreground.scale);
    },

    adjustWrapper: function () {
        const contentWrapperRect = this.contentWrapper.getGlobalBoundingBox();
        const contentRect = cc.rectSubPadding(
            contentWrapperRect,
            cc.multPadding(cc.padding(this.contentWrapperPadding), this.contentWrapper.scale)
        );
        const borderPadding = this.getBorderPadding();

        let windowRect = cc.rectAddPadding(contentRect, borderPadding);
        windowRect = cc.rectAddPadding(windowRect, this.getWindowMinPadding(windowRect));

        const wrapperRect = cc.rectAddPadding(windowRect, this.windowPadding);

        this.window.setContentSize2(windowRect);
        this.wrapper.setContentSize2(wrapperRect);

        this.adjustBackground();
        this.adjustForeground();

        this.wrapper.setPosition(this.convertToNodeSpace(cc.rectGetCenter(wrapperRect)));
        this.window.setPosition(this.window.parent.convertToNodeSpace(cc.rectGetCenter(windowRect)));
        this.contentWrapper.setPosition(this.contentWrapper.parent.convertToNodeSpace(cc.rectGetCenter(contentWrapperRect)));

        if (this.withBg && this.buttons) {
            this.buttons.setPosition(this.buttons.parent.convertToNodeSpace(this.contentItems.convertToWorldSpace(this.buttons.contentItemsPosition)));
            this.buttons.setScale(this.contentWrapper.getScale());
        }

        if (this.styles.alignTop) {
            const sceneSize = cleverapps.resolution.getSceneSize();
            const lovesPosition = this.convertToWorldSpace(cc.p(
                sceneSize.width / 2,
                sceneSize.height / 2 + borderPadding.bottom / 2 - borderPadding.top / 2
            ));
            const availableRect = cleverapps.UI.calcBoundaries(this.getOverlappingNodes(), { lovesPosition });
            const wrapperBox = this.wrapper.getGlobalBoundingBox();
            const availableTop = availableRect.y + availableRect.height;
            const wrapperTop = wrapperBox.y + wrapperBox.height;
            if (availableTop > wrapperTop) {
                this.wrapper.setPosition(this.convertToNodeSpace(cc.p(
                    wrapperBox.x + wrapperBox.width / 2,
                    availableTop - wrapperBox.height / 2
                )));
            }
        }

        // this.content.debugBorder();
        // this.contentWrapper.debugBorder();
    },

    onAfterResize: function () {
        this.wrapper.setScale(1);
        this.wrapper.setAlignment(this.width / 2, this.height / 2);

        this.adjustTapToContinue();

        this.adjustWindowTitle();

        if (!this.params.noScaleAdjustment) {
            const sceneSize = cleverapps.resolution.getSceneSize();
            const borderPadding = this.getBorderPadding();
            const lovesPosition = cc.p(
                sceneSize.width / 2,
                sceneSize.height / 2 + borderPadding.bottom / 2 - borderPadding.top / 2
            );

            const overlappingNodes = this.getOverlappingNodes();
            cleverapps.UI.inflateToBoundaries(this.contentWrapper, overlappingNodes, {
                padding: this.getContentPadding(),
                lovesPosition: this.convertToWorldSpace(lovesPosition),
                maxScale: 1
            });

            this.adjustWrapper();
        }

        this.adjustWindowTitle();

        this.adjustHelpButton();

        if (this.persons) {
            this.persons.update();
        }

        if (this.decors) {
            this.decors.updateAll();
        }

        if (this.tabs) {
            this.tabs.adjustTabs();
        }

        this.wrapper.basePosition = this.wrapper.getPosition();

        // adjust window scale and position while film effect
        const scene = cleverapps.Scenes.GetRunningScene();
        const safePadding = cleverapps.resolution.getSafePadding();
        const position = scene.convertToNodeSpace(cc.p(scene.width / 2 + safePadding.left, scene.height / 2 + safePadding.bottom));
        const scale = 1 / scene.getScale();
        this.setScale(scale);
        this.setPosition(position.x, position.y);
    },

    adjustWindowTitle: function () {
        if (this.windowTitle) {
            this.windowTitle.refresh(this.window);
            this.windowPadding = this.getWindowPadding();
        }
    },

    getOverlappingNodes: function () {
        const scene = cleverapps.Scenes.GetRunningScene();

        const withMenubar = cleverapps.focusManager.isControlEnabled([
            "MenuBarGoldItem", "MenuBarAvatarItem", "MenuBarLivesItem",
            "MenuBarCoinsItem", "MenuBarWandsItem", "MenuBarWorkersItem"]);

        return [
            ...withMenubar ? ComponentUtils.findComponentByName(scene, "UpMenuController").listNodes() : [],
            this.goldInfo,
            this.bottomLine,
            this.windowFooter,
            this.tapToContinue,
            this.windowOffer && this.windowOffer.getOverlapNode()
        ].filter(Boolean);
    },

    getContentPadding: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();

        const backgroundPadding = this.getBackgroundPadding();
        let padding = this.params.contentPadding;

        if (padding === cleverapps.UI.DOCK_RIGHT) {
            padding = { left: sceneSize.width / 2 };
        } else if (padding === cleverapps.UI.DOCK_LEFT) {
            padding = { right: sceneSize.width / 2 };
        } else if (padding === cleverapps.UI.DOCK_BOTTOM) {
            padding = { top: sceneSize.height / 2 };
        } else if (padding === cleverapps.UI.DOCK_TOP) {
            padding = { bottom: sceneSize.height / 2 };
        }

        padding = padding ? cc.mergePaddings([cc.padding(padding), backgroundPadding]) : backgroundPadding;

        padding = cc.paddingAddPadding(padding, this.windowPadding);
        padding = cc.paddingAddPadding(padding, this.getBorderPadding());

        return padding;
    },

    getBorderPadding: function () {
        return this.withBg && this.bg && !this.params.noBorder
            ? cc.multPadding(cc.padding(this.styles.border), this.getBackgroundScale())
            : cc.padding();
    },

    getBackgroundPadding: function () {
        const styles = this.styles || cleverapps.styles.Window;
        return cc.padding(styles.Background.padding);
    },

    getBackgroundScale: function () {
        return !this.params.noBorder && this.styles.border ? this.styles.border.scale[cleverapps.resolution.mode] : 1;
    },

    getWindowMinPadding: function (windowSize) {
        const minWidth = this.params.minWidth !== undefined ? this.params.minWidth : cleverapps.styles.Window.minWidth;
        const minHeight = this.params.minHeight !== undefined ? this.params.minHeight : cleverapps.styles.Window.minHeight;

        const diffX = (minWidth - windowSize.width) / 2;
        const diffY = (minHeight - windowSize.height) / 2;

        return cc.padding({
            x: diffX > 0 ? diffX : 0,
            y: diffY > 0 ? diffY : 0
        });
    },

    getWindowPadding: function () {
        let windowPadding = cc.padding();
        const windowBox = this.window.getGlobalBoundingBox();

        [!this.params.customTitle ? this.windowTitle : undefined].filter(Boolean).forEach((node) => {
            const nodeBox = node.getGlobalBoundingBox();
            windowPadding = cc.mergePaddings([windowPadding, cc.rectUnionPadding(windowBox, nodeBox)]);
        });

        return windowPadding;
    },

    onResizeWhileNotLoaded: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setAlignment(sceneSize.width / 2, sceneSize.height / 2);
    },

    onResize: function () {
        this.onResizeWhileNotLoaded();

        if (this.fireworks) {
            this.fireworks.setAlignment(this.width / 2, this.height / 2);
        }

        if (this.windowFooter) {
            this.windowFooter.setAlignment(this.styles.Footer);
        }

        if (this.windowOffer) {
            this.windowOffer.update();
        }
    },

    createCloseButton: function () {
        let ConstructorClass = CloseRoundButton;
        let params = {
            onClicked: this.close.bind(this),
            styles: this.styles.CloseButton,
            window: this
        };

        if (this.withBg) {
            ConstructorClass = CloseButton;
        } else if (!this.params.notCloseByTouchInShadow) {
            ConstructorClass = TapToContinue;
            params = {
                text: Messages.get(this.params.tapToContinueText || "Window.TapToContinue")
            };
        }

        return new ConstructorClass(params);
    },

    createHelpButton: function (callback) {
        const helpButton = this.helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback
        });

        this.adjustHelpButton();

        return helpButton;
    },

    adjustHelpButton: function () {
        if (!this.helpButton) {
            return;
        }

        const styles = this.styles.HelpButton;
        const scale = styles.scale[cleverapps.resolution.mode];

        this.helpButton.baseScale = scale;
        this.helpButton.setScale(scale);
        this.helpButton.setAlignment(styles.position);
        this.helpButton.setLocalZOrder(styles.zOrder);
    },

    onShow: function () {
        if (this.windowTitle && !this.params.customTitle) {
            this.windowTitle.show();
        }

        if (this.shareCheckBox) {
            this.shareCheckBox.updateState();
        }

        if (this.fireworks) {
            this.fireworks.start();
        }

        if (this.persons) {
            this.persons.showUp();
        }

        if (this.windowOffer) {
            this.windowOffer.show();
        }

        this.hideBeforeDelayedShowUp();
        if (this.params.closeButtonManual) {
            this.params.closeButtonManual = false; // only first time manual, after reopen - all is shown immediately
        } else {
            this.delayedShowUp();
        }

        if (this.params.showSound) {
            cleverapps.effects.fire("ui.window.show", this);
        }
    },

    hideBeforeDelayedShowUp: function () {
        if (this.homeButton) {
            this.homeButton.stopAllActions();
            this.homeButton.setCascadeOpacityEnabledRecursively(true);
            this.homeButton.setVisible(false);
            this.homeButton.setOpacity(0);
        }

        if (this.closeButton) {
            this.closeButton.hide(true);
        }

        if (this.windowFooter) {
            this.windowFooter.setCascadeOpacityEnabledRecursively(true);
            this.windowFooter.setVisible(false);
            this.windowFooter.setOpacity(0);
        }
    },

    delayedShowUp: function () {
        const delay = this.params.closeButtonDelay;

        if (this.homeButton) {
            this.homeButton.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.Show(),
                new cc.FadeIn(0.4).easing(cc.easeOut(1.2))
            ));
        }

        if (this.closeButton) {
            this.closeButton.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.CallFunc(() => {
                    this.closeButton.show();
                    if (!this.params.notCloseByTouchInShadow) {
                        this.enableTouchInShadow();
                    }
                })
            ));
        }

        if (this.windowFooter) {
            this.windowFooter.runAction(new cc.Sequence(
                new cc.DelayTime(delay + 0.5),
                new cc.Show(),
                new cc.FadeIn(0.4).easing(cc.easeOut(1.2))
            ));
        }
    },

    onHide: function () {
        if (this.fireworks) {
            this.fireworks.stop();
        }

        if (this.touchListener) {
            this.touchListener.remove();
            this.touchListener = undefined;
        }

        if (this.windowOffer) {
            this.windowOffer.hide(true);
        }
    },

    createBackground: function () {
        const styles = this.styles.Background;

        const sprite = styles.image;

        const image = cleverapps.skins.getSlot("windowBg", {
            image: sprite,
            level: this.params.level
        });

        const bg = cleverapps.UI.createScale9Sprite(image, styles.scale9);

        if (styles.opacity) {
            bg.setOpacity(styles.opacity);
        }

        bg.setLocalZOrder(-1000);

        return bg;
    },

    createForeground: function (image) {
        this.foreground = cleverapps.UI.createScale9Sprite(image, cleverapps.UI.Scale9Rect.TwoPixelXY);

        if (cleverapps.config.debugMode) {
            this.foreground._debugExclude = true;
        }

        this.foreground.setAnchorPoint(0, 0);
        this.foreground.setLocalZOrder(1);

        this.adjustForeground();

        return this.foreground;
    },

    onTouchInShadow: function () {
        cleverapps.effects.fire("ui.button.haptic");
        this.close();
    },

    setTitle: function (title) {
        if (this.windowTitle) {
            this.windowTitle.setTitle(title);
        }
    },

    getMinimalDialogueRects: function () {
        const styles = cleverapps.styles.Window;
        const rects = [
            cc.rectSubPadding(this.window.getSceneBoundingBox(), cc.padding(styles.BoundingBoxPadding))
        ];
        if (this.windowTitle) {
            rects.push(cc.rectSubPadding(this.windowTitle.getSceneBoundingBox(), cc.padding(styles.BoundingBoxPadding.Title)));
        }
        return rects;
    },

    enableTouchInShadow: function () {
        cleverapps.UI.onClick(this, (touch) => {
            this.onTouchInShadow(touch);
        }, {
            interactiveScale: false,
            filter: (touch) => {
                if (this.window && !(this.closeButton instanceof TapToContinue)) {
                    const size = this.window.getContentSize();
                    const rect = cc.rect(0, 0, size.width, size.height);

                    if (cc.rectContainsPoint(rect, this.window.convertToNodeSpace(touch.getLocation()))
                        || cc.rectContainsPoint(rect, this.window.convertToNodeSpace(touch.getStartLocation()))) {
                        return false;
                    }
                }

                return true;
            }
        });
    },

    popUpAnimation: function () {
        const animation = this.chooseAnimation();
        if (animation) {
            if (this.window) {
                this.window.stopAllActions();
            }
            animation.open.call(this, this.onPopUpAnimationFinished.bind(this));
        } else {
            this.onPopUpAnimationFinished();
        }
    },

    onPopUpAnimationFinished: function () {

    },

    closeAnimation: function (callback) {
        cleverapps.effects.fire("ui.window.close", this);

        const animation = this.chooseAnimation();

        if (!animation || (cleverapps.focusManager.listWindows().length > 1 && !this.styles.windowShowUpAnimation.force)) {
            callback();
        } else {
            animation.close.call(this, callback);
        }
    },

    chooseAnimation: function () {
        const styles = this.styles || cleverapps.styles.Window;
        if (styles.windowShowUpAnimation && this.window) {
            if (!this.bg && !styles.windowShowUpAnimation.force) {
                return WINDOW_ANIMATIONS.default;
            }
            return WINDOW_ANIMATIONS[styles.windowShowUpAnimation.name];
        }
    },

    closeDuration: function () {
        const styles = this.styles || cleverapps.styles.Window;
        return styles.closeAnimation.duration;
    },

    close: function () {
        ComponentMap.get(this, WindowComponent).closeWindow();
    },

    onClose: function () { },

    hideComponents: function () {
        if (this.window) {
            this.window.stopAllActions();
        }

        if (cleverapps.oneOf(this.closeButton, CloseRoundButton)) {
            this.closeButton.hide();
        }

        if (this.tapToContinue) {
            this.tapToContinue.runAction(new cc.Sequence(
                new cc.FadeOut(0.3),
                new cc.Hide()
            ));
        }

        if (this.homeButton) {
            this.homeButton.runAction(new cc.Sequence(
                new cc.FadeOut(0.3),
                new cc.Hide()
            ));
        }

        if (this.windowFooter) {
            this.windowFooter.runAction(new cc.Sequence(
                new cc.FadeOut(0.3),
                new cc.Hide()
            ));
        }

        if (this.windowTitle && !this.withBg) {
            this.windowTitle.hide();
        }

        if (this.decors) {
            this.decors.hideAll();
        }

        if (this.content) {
            this.content.children.forEach((component) => {
                if (component.hide) {
                    component.hide();
                }
            });
        }
    },

    getPerson: function () {
        return undefined;
    },

    _findInjectedPersons: function () {
        for (const name of this._listedBundles || []) {
            const bundle = bundles[name];
            if (bundle && bundle.jsons && (bundle.jsons.personLeft || bundle.jsons.personRight)) {
                return {
                    left: bundle.jsons.personLeft ? { json: bundle.jsons.personLeft } : undefined,
                    right: bundle.jsons.personRight ? { json: bundle.jsons.personRight } : undefined
                };
            }
        }
    },

    getPersonBundles: function () {
        const personBundles = [];
        const person = this.getPerson();
        if (person) {
            let left, right;

            if (person.left || person.right) {
                left = person.left;
                right = person.right;
            } else {
                left = person;
            }

            [left, right].filter(Boolean).forEach((personRole) => {
                const role = personRole.role || personRole;
                const personObject = cleverapps.persons.getRole(role);
                if (personObject && personObject.bundle) {
                    personBundles.push(personObject.bundle);
                }
            });
        }

        return personBundles;
    },

    getLoadingTasks: function () {
        return [];
    },

    listBundles: function () {
        return [];
    },

    listLazyUrls: function () {
        return [];
    },

    _composeBundles: function (...args) {
        this._listedBundles = this.listBundles(...args) || [];
        let allBundles = this._listedBundles.slice();
        if (cleverapps.skins.getBundles()) {
            allBundles = allBundles.concat(cleverapps.skins.getBundles());
        }
        allBundles.push("windows");

        const personsBundles = this.getPersonBundles();
        if (personsBundles) {
            allBundles = allBundles.concat(personsBundles);
        }

        allBundles = cleverapps.unique(allBundles);
        allBundles = allBundles.filter((name) => bundles[name]);

        return allBundles;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CLOSE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.Window = {
    margin: 30,

    border: {
        scale: [0.8, 1, 1],
        x: 35,
        top: 110,
        bottom: 20
    },
    padding: {
        x: 50,
        top: 50,
        bottom: 30
    },

    titleMargin: 30,

    HelpButton: {
        zOrder: 1,
        scale: [0.8, 1, 1],
        position: {
            x: { align: "left", dx: 70 },
            y: { align: "top", dy: -45 }
        }
    },
    BottomButton: {
        width: 200,
        height: 90
    },
    HomeButton: {
        position: {
            x: { align: "right", dx: -40 },
            y: { align: "top", dy: -15 }
        }
    },

    minHeight: 200,
    minWidth: 240,

    windowShowUpAnimation: {
        name: "default",
        force: false
    },

    Background: {
        image: bundles.windows.frames.window_bg_png,
        scale9: cleverapps.UI.Scale9Rect.TwoPixelXY,
        padding: {
            x: 10,
            y: 30
        }
    },

    Footer: {
        x: { align: "center" },
        y: { align: "bottom", dy: 60 },

        margin: 20
    },

    BoundingBoxPadding: {
        x: 30,
        y: 30,
        Title: {
            x: 30,
            y: 30
        }
    },

    TapToContinue: {
        padding: {
            bottom: 60
        }
    }
};
